import { Dialog, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { WbCard } from '../WbCard';
import { MultiSelectionPickerContextProvider } from './MultiSelectionPickerContext';
import { PickerContent, WbMultiSelectionPickerProps } from './PickerContent';
import { useResponsiveMobile } from '../../hooks';

export function WbMultiSelectionPickerDialog<T>(
  props: WbMultiSelectionPickerProps<T>,
) {
  const {
    open,
    setOpen,
    selectedValues,
    setSelectedValues,
    children,
    title,
    fetchAiData,
  } = props;

  const isMobile = useResponsiveMobile();
  return (
    <Dialog
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      maxWidth="xl"
      fullScreen={isMobile}
      fullWidth
    >
      <WbCard
        title={`${title} Picker`}
        headerContentStyle={{ height: 'auto', padding: '8px 16px' }}
        cardStyle={{
          boxShadow: 'none',
          display: 'flex',
          flexDirection: 'column',
        }}
        actions={
          <IconButton
            aria-label="close"
            onClick={() => setOpen(false)}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        }
      >
        <MultiSelectionPickerContextProvider<T>
          selectedValues={selectedValues}
          setSelectedValues={setSelectedValues}
          fetchAIData={fetchAiData}
        >
          <PickerContent contentHeight="65vh" {...props}>
            {children}
          </PickerContent>
        </MultiSelectionPickerContextProvider>
      </WbCard>
    </Dialog>
  );
}
